export const MessagesIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#yvymh29gva)">
			<path
				d="M14 4h-1.333v6H4v1.333c0 .367.3.667.667.667H12l2.667 2.667v-10c0-.367-.3-.667-.667-.667zm-2.667 4V2c0-.367-.3-.667-.666-.667H2c-.367 0-.667.3-.667.667v9.333L4 8.667h6.667c.366 0 .666-.3.666-.667z"
				fill="#367BF5"
			/>
		</g>
		<defs>
			<clipPath id="yvymh29gva">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);
export const MessagesBorder = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#d279kij91a)" stroke="#7EA6B4" stroke-width="1.5">
			<path d="M14 4v10l-2.333-3H5" stroke-linecap="round" />
			<path d="M3.424 8.333 1 11V1.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v6.333a.5.5 0 0 1-.5.5H3.424z" />
		</g>
		<defs>
			<clipPath id="d279kij91a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const AdjustedIcon = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="1.4" y="1.4" width="17.2" height="17.2" rx="2.6" stroke="#7EA6B4" stroke-width="1.2" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.2 4H10.8V7.2H14V8.8H10.8V12H9.2V8.8H6V7.2H9.2V4ZM6 16H14V14.5H6V16Z"
			fill="#7EA6B4"
		/>
	</svg>
);

export const AdjustedBorderIcon = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="0.5" y="0.5" width="17" height="17" rx="2.5" fill="#367BF5" stroke="#367BF5" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M8.2 3H9.8V6.2H13V7.8H9.8V11H8.2V7.8H5V6.2H8.2V3ZM5 15H13V13.5H5V15Z"
			fill="white"
		/>
	</svg>
);

export const DeltaIcon = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="1.4" y="1.4" width="17.2" height="17.2" rx="2.6" stroke="#7EA6B4" stroke-width="1.2" />
		<path d="M10 5L15 14H5L10 5Z" fill="#7EA6B4" />
	</svg>
);

export const DeltaBorderIcon = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="0.5" y="0.5" width="17" height="17" rx="2.5" fill="#367BF5" stroke="#367BF5" />
		<path d="M9 3L13 15H5L9 3Z" fill="white" />
	</svg>
);
